import { render } from "./ZamgRectangleTemplate.vue?vue&type=template&id=7e0f4e92&ts=true"
import script from "./ZamgRectangleTemplate.vue?vue&type=script&lang=ts"
export * from "./ZamgRectangleTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__